import React from 'react'
import  { observer, inject } from 'mobx-react'
import Input from 'material-ui/Input'
import T from 'i18n-react'
import {
  FormLabel,
  FormControl,
  FormGroup,
  FormControlLabel,
  FormHelperText,
} from 'material-ui/Form';
import List, { ListItem, ListItemSecondaryAction, ListItemText } from 'material-ui/List'
import Checkbox from 'material-ui/Checkbox'
import Paper from 'material-ui/Paper'
import Button from 'material-ui/Button'
import ButtonBase from 'material-ui/ButtonBase'
import Avatar from 'material-ui/Avatar'
import Typography from 'material-ui/Typography'
import Lehrplan, { CompetenceStepPopover } from './lehrplan'
import Chip from 'material-ui/Chip'
import { findDOMNode } from 'react-dom'
import Icon from 'material-ui/Icon'
import IconButton from 'material-ui/IconButton'
import { debounce } from 'throttle-debounce'


@inject('store','ui') @observer
export class Search extends React.Component {
  constructor () {
    super()
    this.search = debounce(700, this.search)
  }

  render () {
    const {store,ui} = this.props
    return (
      <Input
       placeholder={T.translate("search.title")}
       className="catalog-searchbar"
       disableUnderline={true}
       value={store.query}
       autoFocus={ui.search.isSearchOpen}
       inputProps={{
         'aria-label': 'Search',
       }}
       onChange={this.onChange}
       onKeyDown={this.onKeyDown}
      />
    )
  }

  onChange = (event) => {
   this.props.store.setQuery(event.target.value)
   this.search()
  }

  search = (query) => {
    this.props.store.resetCatalog()
  }

  onKeyDown = (event) => {
    if (event.keyCode === 13 || event.which === 13) {
      this.props.store.resetCatalog()
    }
  }
}

@inject('store','ui') @observer
export class ClearFilter extends React.Component {
 render () {
   const { store } = this.props
   let clearFilter = null

   if (store.hasUserDefinedFilters) {
     clearFilter =
      <Button raised color="secondary" className="catalog-clear-search-filter center-flex" onClick={store.clearFilter}>
       {T.translate("search.clearFilter")}
      </Button>
   }
   return ( clearFilter )
 }
}

@inject('store','ui') @observer
export class Filter extends React.Component {
  render () {
    const { store,ui } = this.props, chipData = store.getChipData()
    return (
      <div className="catalog-search-filter">

       <FormControl component="fieldset" className="width-100p">
        <FormLabel component="legend">{T.translate("meta.cycle")}</FormLabel>
        <div className="catalog-search-filter-pad-marg center-flex">
         <CycleFilter cycle={1} />
         <CycleFilter cycle={2} />
         <CycleFilter cycle={3} />
        </div>
       </FormControl>

       <FormControl component="fieldset" className="width-100p">
        <FormLabel component="legend">{T.translate("meta.competenceSteps")}</FormLabel>
        <div className="catalog-search-filter-pad-marg center-flex">

         <div className="chip-container">
          {chipData.map( ks => {
           return (
             <Chip
              className="lehrplan-chip"
              avatar={<Avatar className={ui.getZyklusColor(ks)}> {ui.getZyklusAsString(ks)} </Avatar>}
              key={ks.code}
              label={ks.code}
              onClick={this.openPopover.bind(this,ks)}
              onDelete={store.toggleCompetenceStepFilter.bind(this,ks.id)}
              ref={ chip => {this.chip = chip} }
             />
            )
           })}
          <CompetenceStepPopover />
         </div>

         <div>
          <IconButton color="secondary" onClick={ui.lehrplan.handleOpen}>
           <Icon>add</Icon>
          </IconButton>
          <Lehrplan
           lehrplan={store.lehrplan}
           onSelection={store.setCompetenceStepFilter}
           preSelection={store.competenceStepFilter}
           label={T.translate("lehrplan.choose")}
          />
         </div>

        </div>
       </FormControl>

       <FormControl component="fieldset">
        <FormLabel component="legend">{T.translate("search.categories")}</FormLabel>
        <FormGroup>

         <List>
          {store.beispieltypen.map( (type,index) => {
            if (!type.deleted) {
             return <FilterCheckbox key={index} item={type} />
            }
          })}
         </List>

        </FormGroup>
       </FormControl>
      </div>
    )
  }

  openPopover (ks) {
    const ui = this.props.ui.lehrplan, anchorEl = findDOMNode(this.chip)

    ui.setPopoverAnchorEl(anchorEl)
    ui.handleOpenStepPopover(ks)
  }

}

@inject('store') @observer
class FilterCheckbox extends React.Component {
  render () {
    const { item,store } = this.props
    const isChecked = store.isActiveTypeFilter(item.id)

    return (
      <ListItem dense button onClick={store.toggleTypeFilter.bind(this,item.id)}>
       <Avatar className="catalog-search-avatar"> {store.getBeispielTypFirstChar(item.name)} </Avatar>
       <ListItemText primary={item.name} />
       <ListItemSecondaryAction>
        <Checkbox
         checked={isChecked}
         disableRipple
         onChange={store.toggleTypeFilter.bind(this,item.id)}
        />
       </ListItemSecondaryAction>
     </ListItem>
    )
  }


}

@inject('ui','store') @observer
class CycleFilter extends React.Component {
  render () {
    const { cycle, store } = this.props
    let elevation = 6, enabled = false, color = "catalog-zyklus-disabled"

    if (cycle === 1) {
      if (store.zyklus1) {elevation = 0; enabled = true}
    }
    else if (cycle === 2) {
      if (store.zyklus2) {elevation = 0; enabled = true}
    }
    else if (cycle === 3) {
      if (store.zyklus3) {elevation = 0; enabled = true}
    }

    if (enabled) color = "catalog-item-color-zyklus-"+cycle

    return (
      <Paper
       className={"catalog-cycle-filter " + color}
       elevation={elevation}
       onClick={this.toggleCycle}
      >
       <ButtonBase focusRipple>
        {cycle}
       </ButtonBase>
      </Paper>
    )
  }

  toggleCycle = () => {
    this.props.store.toggleCycle(this.props.cycle)
  }
}



// WEBPACK FOOTER //
// ./src/components/search.js